import axios from "axios"

/* export default axios.create({
      baseURL: "http://localhost:3005",
  }); */

export default axios.create({
    baseURL: "https://agora-lms.herokuapp.com",
  });